import React from 'react';
import { Route, Switch } from "react-router-dom";
import CaMakerReportsModule from "./ca-maker-reports-module/ca-maker-reports-module";

const Maker_Reports = () => {
  return (
    <Switch>
      <Route exact path="/security">
        <CaMakerReportsModule />
      </Route>
    </Switch>
  )
}

export default Maker_Reports;